export const dbTabs2 = {
  ageRules: {
    heading: "Regras de hóspedes",
    headHint:
      "Defina quem conta como bebê, criança ou adulto e como contam para a capacidade {scope}. Por padrão, os bebês não ocupam vaga e não são cobrados.",
    scopeHotel: "de cada quarto",
    scopeApartment: "da acomodação",
    loading: "Carregando regras…",
    emptyHotel: "Este hotel não tem quartos configurados.",
    capacityChipTitle: "Capacidade do quarto (definida em Capacidade)",
    slots: "{count} vaga | {count} vagas",
    badgeCustom: "Personalizado",
    badgeStandard: "Padrão",
    applyAgeRules: "Aplicar regras de idade",
    masterSubHotel: "Bebês, crianças e capacidade personalizados para este quarto.",
    masterSubApartment: "Bebês, crianças e capacidade personalizados para esta acomodação.",
    standardNote:
      "Comportamento padrão: os bebês não contam para a capacidade e não são cobrados.",
    capacityLabel: "Capacidade",
    capacityGuestsNote:
      'hóspede · definido em "Capacidade"; estas regras só ajustam quem conta | hóspedes · definido em "Capacidade"; estas regras só ajustam quem conta',
    infantUpTo: "Bebês têm até",
    years: "anos",
    childToAdult: "Uma criança se torna adulto aos",
    maxInfants: "Máximo de bebês",
    perBooking: "por reserva",
    infantsOccupy: "Os bebês ocupam uma vaga",
    infantsCharged: "Os bebês são cobrados",
    childrenCount: "As crianças contam como hóspede",
    ageLegend:
      "Bebê: menos de {infant} anos · Criança: {infant}–{childTo} anos · Adulto: {adult}+ anos.",
    listingCapacity: "Capacidade do anúncio",
    listingCapacityHint: 'Definida em "Capacidade" e compartilhada com "Ocupação".',
    thisAccommodation: "Esta acomodação",
    loadError: "Não foi possível carregar as regras de hóspedes.",
    saveSuccess: "Regras de hóspedes salvas com sucesso.",
    saveError: "Não foi possível salvar as regras de hóspedes.",
  },
  globalPayments: {
    title: "Pagamentos globais (Apartamentos/Vilas)",
    pill: "Global",
    desc: "Esta configuração se aplica a todas as propriedades de apartamento/vila do usuário.",
    loading: "Carregando configurações…",
    paymentType: "Tipo de pagamento",
    onArrivalLabel: "Pagar na chegada",
    onArrivalDesc: "O hóspede reserva e paga diretamente na chegada.",
    onlineLabel: "Pagamento online",
    onlineDesc: "O hóspede paga online ao concluir a reserva.",
    savedAtUserLevel: "Salvo no nível do usuário para apartamentos/vilas.",
    globalDiscount: "Desconto global",
    enableGlobalDiscount: "Ativar desconto global",
    discountType: "Tipo de desconto",
    percentageLabel: "Porcentagem",
    percentageDesc: "Desconto proporcional ao total.",
    fixedLabel: "Fixo",
    fixedDesc: "Valor fixo a descontar.",
    valueTitle: "Valor",
    phPercentage: "ex.: 10",
    phFixed: "ex.: 15,00",
    helpPercentage: "Até 100%. Aplicado ao total.",
    helpFixed: "Um valor fixo em {currency} é descontado.",
    previewTitle: "Prévia",
    previewPercentage: "Será aplicado um desconto global de {percent}%.",
    previewFixed: "Será aplicado um desconto global de {amount}.",
    appliesAllDirect: "Aplica-se a todas as reservas diretas de apartamentos/vilas.",
    saveSuccess: "Pagamentos globais salvos.",
    saveError: "Não foi possível salvar os pagamentos globais.",
  },
  payments: {
    loading: "Carregando configurações…",
    q02Title: "Quando o hóspede paga?",
    savingBadge: "Salvando…",
    payOnArrivalName: "Pagar na chegada",
    payOnArrivalHint: "O hóspede reserva e paga diretamente na chegada.",
    payOnlineName: "Pagamento online",
    payOnlineHint: "O hóspede paga online ao concluir a reserva.",
    q03Title: "Tempo para pagar",
    onlineOnlyBadge: "Somente pagamento online",
    holdDesc:
      "O calendário fica bloqueado enquanto o hóspede conclui o pagamento.<br>Se não pagar dentro do tempo definido, <strong>a disponibilidade é liberada automaticamente</strong>.",
    unitMin: "min",
    unitHour: "hora",
    unitHours: "horas",
    q04Title: "Pagamento parcial",
    partialTitle: "Permitir pagar só uma parte na reserva",
    partialOnDesc:
      "<strong>Ativado.</strong> O hóspede pode pagar <strong>{percent}%</strong> agora e o restante antes da chegada (ou pagar o total).",
    partialOffDesc:
      "<strong>Desativado.</strong> O hóspede paga o <strong>valor total</strong> na reserva.",
    blockTitle: "O restante é pago na acomodação",
    blockOnDesc:
      "<strong>Ativado.</strong> O hóspede paga <strong>apenas {percent}%</strong> online; o restante é pago <strong>na chegada</strong> (não pode pagar o total online).",
    blockOffDesc:
      "<strong>Desativado.</strong> O hóspede pode escolher pagar {percent}% ou o valor total online.",
    q05Title: "Lembrete de saldo",
    reminderTitle: "Enviar um lembrete para pagar o saldo pendente",
    reminderOnDesc:
      "<strong>Ativado.</strong> <strong>{when}</strong> da chegada (por volta das 09:00, horário da propriedade) o hóspede recebe um link para pagar o saldo pendente por <strong>WhatsApp e e-mail</strong>.",
    reminderOffDesc:
      "<strong>Desativado.</strong> O hóspede não recebe um lembrete para pagar o saldo online antes da chegada.",
    daysBefore: "{count} dia antes | {count} dias antes",
    reminderDaysLabel: "Dias antes da chegada",
    reminderHint:
      "Enviado uma vez, e somente a hóspedes com saldo pendente. Se o restante for pago na acomodação, não é enviado.",
    approveTitle: "Aprovar reservas",
    approveCardTitle: "Aprovar cada reserva antes de ser confirmada",
    approveOnDesc:
      "<strong>Ativado.</strong> Cada reserva fica <strong>pendente da sua aprovação</strong>: você recebe uma notificação e decide se aceita ou recusa. Não é confirmada até você aprovar.",
    approveOffDesc:
      "<strong>Desativado.</strong> As reservas <strong>se confirmam sozinhas</strong> assim que o pagamento é concluído. Ative se preferir revisar e aprovar cada solicitação você mesmo.",
    saveSuccess: "Salvo.",
    saveError: "Não foi possível salvar as alterações.",
  },
  unitConfig: {
    descByRoom: "Descrição por quarto",
    descByRoomHint:
      "Cada quarto tem sua própria descrição e sua própria visibilidade na reserva direta.",
    loadingRooms: "Carregando quartos…",
    emptyHotel: "Este hotel não tem quartos configurados.",
    visible: "Visível",
    hidden: "Oculto",
    roomDescPlaceholder: "Descreva {name} (camas, comodidades, vistas…)",
    savingDesc: "Salvando…",
    autosaveHint: "Salvo automaticamente ao sair do campo.",
    loadingProperty: "Carregando dados da acomodação…",
    loadErrorProperty: "Não foi possível carregar as configurações desta acomodação.",
    amenitiesByRoom: "Comodidades por quarto",
    amenitiesByRoomHint:
      "Cada quarto pode oferecer comodidades diferentes. A reserva direta e o Agente de IA usam as do quarto atribuído ao hóspede.",
    amenitiesCount: "{count} comodidade | {count} comodidades",
    noAmenities: "Sem comodidades",
    titleDescription: "Descrição da acomodação",
    titleServices: "Equipamentos e comodidades",
    subtitleDescription:
      "Edite a descrição que os hóspedes verão na sua página de reserva direta.",
    subtitleServices: "Marque o que este alojamento oferece e envie as fotos.",
  },
};
